(function() {
  const storyHostSelector = 'loox-reviews-stories-entry-widget';

  function hasRenderedStory(host) {
    if (!host || !host.shadowRoot || host.hidden || getComputedStyle(host).display === 'none') return false;

    const entry = host.shadowRoot.querySelector('.reviews-stories-entry-widget-container');
    if (!entry || entry.hidden || getComputedStyle(entry).display === 'none') return false;

    // Loox can mount an empty widget for products without a generated story.
    // Only an entry point with content should replace the review scroller.
    const hasCopy = Boolean(entry.textContent && entry.textContent.trim());
    const hasEntryPoint = Boolean(entry.querySelector('button, a, [role="button"], [tabindex]:not([tabindex="-1"]), img, video'));
    return hasCopy && hasEntryPoint;
  }

  function initStoryWrapper(wrapper) {
    if (wrapper.dataset.pdpStoriesLayoutBound === 'true') return;
    wrapper.dataset.pdpStoriesLayoutBound = 'true';

    const productBlocks = wrapper.closest('[data-product-blocks]');
    let host = null;
    let shadowRoot = null;
    let shadowObserver = null;
    let storyVisible = false;

    function centreShadowContent() {
      if (!shadowRoot || shadowRoot.querySelector('[data-pdp-stories-centre-style]')) return;
      const style = document.createElement('style');
      style.setAttribute('data-pdp-stories-centre-style', 'true');
      style.textContent = '@media (min-width: 769px) {' +
        '.reviews-stories-entry-widget-container { justify-content: center !important; }' +
        '}';
      shadowRoot.appendChild(style);
    }

    function syncVisibility() {
      const nextVisible = hasRenderedStory(host);
      if (nextVisible === storyVisible) return;
      storyVisible = nextVisible;
      wrapper.classList.toggle('has-story', nextVisible);
      wrapper.setAttribute('aria-hidden', String(!nextVisible));
      if (nextVisible) wrapper.removeAttribute('inert');
      else wrapper.setAttribute('inert', '');
      const scroller = productBlocks && productBlocks.querySelector('.pdp-loox-snippets-block');
      if (scroller) scroller.classList.toggle('is-hidden-by-story', nextVisible);
    }

    function connectHost() {
      const nextHost = wrapper.querySelector(storyHostSelector);
      if (nextHost !== host) {
        if (shadowObserver) shadowObserver.disconnect();
        host = nextHost;
        shadowRoot = null;
      }

      if (host && host.shadowRoot && host.shadowRoot !== shadowRoot) {
        shadowRoot = host.shadowRoot;
        shadowObserver = new MutationObserver(syncVisibility);
        shadowObserver.observe(shadowRoot, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
        centreShadowContent();
      }
      syncVisibility();
    }

    const lightObserver = new MutationObserver(connectHost);
    lightObserver.observe(wrapper, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    connectHost();

    // The custom element can attach its shadow root after the app block mounts.
    let attempts = 0;
    const retry = window.setInterval(function() {
      connectHost();
      attempts += 1;
      if (shadowRoot || attempts >= 60) window.clearInterval(retry);
    }, 500);

    if (window.customElements && window.customElements.whenDefined) {
      window.customElements.whenDefined(storyHostSelector).then(connectHost);
    }
  }

  function initLooxStoriesLayout() {
    document.querySelectorAll('.pdp-loox-stories-block').forEach(initStoryWrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLooxStoriesLayout, { once: true });
  } else {
    initLooxStoriesLayout();
  }
  document.addEventListener('shopify:section:load', initLooxStoriesLayout);
})();
